module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av244-846a568d9ee08ee3539738ec64e584d7.jpg";